import { useEffect, useState } from 'react';
import useAxios from "../plugins/useAxios";
import SiteCard from "../components/SwitchScreen/SiteCard";

const SiteSwitchScreen = () => {
    const [sites,setSites] = useState([])

    const getSites = () => {
       useAxios.get('sites').then((res) => {
        setSites(res.data)
       })
       .catch((err) => {

       })
    }

    useEffect(() => {
        getSites()
    },[])

    return (
        <div className="w-full min-h-screen items-center bg-gradient-to-br from-gray-800 via-gray-900 to-black absolute top-0 left-0 md:p-20 p-8 z-50">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-bold text-white mb-4">Seleziona Parcheggio</h1>
                    <p className="text-gray-400 text-lg">Scegli il sito che vuoi monitorare</p>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
                    {sites.length === 0 ? (
                        <div className="col-span-full text-center py-20">
                            <div className="text-gray-500 text-xl">Nessun sito disponibile</div>
                        </div>
                    ) : (
                        sites.map((item, key) => {
                            return ( <SiteCard key={key} item={item} /> )
                        })
                    )}
                </div>
            </div>
        </div>
    )   
}

export default SiteSwitchScreen;